import React, { useState, useEffect } from "react";
import axios from "axios";
import { CiUser, CiEdit, CiTrash } from "react-icons/ci";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { AiOutlineCloseCircle } from "react-icons/ai";
import Utils from "../../utils/utils";
import { useToast } from "../ToastContext";
import QuestionList from "./QuestionList";

const AdminAssignmentCard = ({
  item,
  index,
  onEdit,
  onView,
  setAssignments,
}) => {
  // const { item, index, onEdit, onView, setAssignments } = props;
  const token = Utils.getToken();
  const showToast = useToast();
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;

  const [oldDueDate, setOldDueDate] = useState({ endDate: "", endTime: "" });
  const [dueDate, setDueDate] = useState({ endDate: "", endTime: "" });

  const [editMode, setEditMode] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [anyOneCanSee, setAnyOneCanSee] = useState(item.anyone ? true : false);

  const [endDateTime, setEndDateTime] = useState({ date: "", time: "" });
  const [formData, setFormData] = useState({
    title: item.title,
    remarks: item.remarks,
    description: item.description,
    batch: item.batch,
    endTime: endDateTime.time,
    endDate: endDateTime.date,
  });

  const [dueDateEditing, setDueDateEditing] = useState(false);
  const [showQuestions, setShowQuestions] = useState(false);
  const [showDueDates, setShowDueDates] = useState(false);

  // == Handlers
  const handleDueDateChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setDueDate((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // useEffect(() => {
  //   if (item?.dueDate) {
  //     const { date, time } = Utils.getDateTimeUTCToLocal(item.dueDate);
  //     // setEndDateTime({ date, time });
  //     // setFormData((prev) => ({ ...prev, endTime: time, endDate: date }));
  //   }
  // }, [item?.dueDate]);

  const HandleDueDateChange = async (id) => {
    const endDate = Utils.getCreationTime(dueDate.date, dueDate.time);

    try {
      const response = await axios.get(
        `${SERVER_URL}/assignments/dueDate/${id}`,
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(),
        }
      );
      if (response.status === 200) {
        const res = response.data.data;
        // setAssignment(response.data.data);
      } else {
        showToast(response.statusText, "error", true, 5000);
        return;
      }
    } catch (error) {
      console.log("Catch => " + error.message);
      showToast(error.message, "error", true, 5000);
    }
  };

  const HandleDeleteAssignment = async (id) => {
    const confirm = window.confirm("Are you sure ?");
    if (!confirm) return;
    try {
      const response = await axios.delete(`${SERVER_URL}/assignments/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        const res = response.data;
        console.log(res);
        setAssignments((prev) => prev.filter((item) => item._id !== id));
      } else {
        showToast(response.statusText, "error", true, 5000);
        return;
      }
    } catch (error) {
      // console.log("Catch => " + error.message);
      showToast(error.message, "error", true, 5000);
    }
  };

  const HandleAssignAssignment = async (id) => {
    const confirm = window.confirm(
      "Are you sure ? \nOnce the assignment has been assigned you can't Edit and Delete !"
    );
    if (!confirm) return;
    try {
      const response = await axios.put(
        `${SERVER_URL}/assignments/assign/${id}`,
        { assigned: true },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 201) {
        const res = response.data;
        const updated = res.assignment;
        showToast(res.message, "success", true, 3000);
        setAssignments((prev) => prev.map((x) => (x._id === id ? updated : x)));
      } else {
        if (response.status === 422);
        showToast(response.statusText, "error", true, 5000);
        return;
      }
    } catch (error) {
      console.log("Catch => " + error.message);
      showToast(error.message, "error", true, 5000);
    }
  };

  return (
    <div
      bkl="AdminAssignmentCard"
      key={`AdminAssignmentCard-${item._id}-${index * index}`}
      className="group relative mb-4 overflow-hidden rounded-xl border bg-white p-6 transition-all hover:shadow-lg"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div
        className="
        absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-pink-600 to-pink-800"
      />

      <div key={"AdminAssignmentCardView" + index} className="">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
          <div className=" order-2 flex-1 space-y-4 sm:order-1 ">
            <div>
              <h3 className="font-semibold text-gray-900">{item.title}</h3>
              {item.description && (
                <p className="mt-1 text-sm text-gray-600">{item.description}</p>
              )}
              {item.remarks && (
                <p className="mt-2 text-sm italic text-gray-500">
                  {item.remarks}
                </p>
              )}
            </div>

            {/* {dueDateEditing ? (
              <div className="flex items-center gap-3">
                <form className="flex gap-2">
                  <input
                    type="date"
                    name="endDate"
                    value={dueDate.endDate}
                    onChange={handleDueDateChange}
                    required
                    className="rounded-lg border-gray-200 bg-gray-50 px-3 py-2 text-sm focus:border-pink-500 focus:outline-none focus:ring-1 focus:ring-pink-500"
                  />
                  <input
                    type="time"
                    name="endTime"
                    value={dueDate.endTime}
                    onChange={handleDueDateChange}
                    required
                    className="rounded-lg border-gray-200 bg-gray-50 px-3 py-2 text-sm focus:border-pink-500 focus:outline-none focus:ring-1 focus:ring-pink-500"
                  />
                </form>
                <button
                  onClick={() => setDueDateEditing(false)}
                  className="rounded-lg bg-green-50 p-2 text-green-600 hover:bg-green-100"
                >
                  <IoCheckmarkDoneCircleOutline
                    size={18}
                    onClick={() => {
                      // setBatchChange(true);
                    }}
                  />
                </button>

                <button
                  className="rounded-lg bg-red-50 p-2 text-red-600 hover:bg-red-100"
                  title="Edit"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setDueDateEditing(false);
                  }}
                >
                  <AiOutlineCloseCircle
                    size={18}
                    onClick={() => {
                      // setBatchChange(true);
                    }}
                  />
                </button>
              </div>
            ) : (
              <div className="flex flex-wrap gap-2 mt-4">
                {Object.entries(item.dueDates).map(([batch, date]) => (
                  <div
                    key={batch}
                    className="card w-fit bg-white shadow-md border border-gray-200 rounded-lg hover:shadow-lg transition-shadow"
                  >
                    <button className="inline-flex items-center gap-2 rounded-lg bg-red-50 px-3 py-1.5 text-sm font-medium">
                      <span className="text-red-600">{batch}</span>
                      <span className="text-gray-600">
                        {Utils.formatDateTime(date)}
                      </span>
                    </button>
                  </div>
                ))}

                <button className="inline-flex items-center gap-2 rounded-lg bg-red-50 px-3 py-1.5 text-sm font-medium">
                  <span className="text-red-600">Due By</span>
                  <span className="text-gray-600">
                    {Utils.formatDateTime(item.dueDate)}
                  </span>
                </button>
                <div className="bg-white h-fit shadow-md rounded-md p-1 cursor-pointer hover:shadow-lg hover:shadow-blue-200">
                  <CiEdit
                    className="text-blue-600 hover:text-blue-800"
                    title="Edit"
                    onClick={() => {
                      setDueDateEditing(true);
                    }}
                  />
                </div>
              </div>
            )} */}
          </div>

          <div className="order-1 flex flex-col gap-3 sm:order-2 ">
            <div className="flex gap-2">
              <button
                className="inline-flex items-center gap-1 rounded-lg border border-blue-200 px-3 py-1.5 text-xs font-medium tracking-wide text-blue-600 transition-colors hover:bg-blue-50"
                onClick={onEdit}
              >
                <CiEdit size={14} /> EDIT
              </button>
              {!item.assigned && (
                <button
                  className="inline-flex items-center gap-1 rounded-lg border border-red-200 px-3 py-1.5 text-xs font-medium tracking-wide text-red-600 transition-colors hover:bg-red-50"
                  onClick={(e) => {
                    e.stopPropagation();
                    HandleDeleteAssignment(item._id);
                  }}
                >
                  <CiTrash size={14} /> Delete
                </button>
              )}
            </div>

            {/* {!item.assigned ? (
                <button
                  className="rounded-lg px-4 py-2 text-white bg-[#3470E4] whitespace-nowrap transition-all duration-200 tracking-[1px] hover:tracking-[1.25px] hover:bg-blue-800"
                  title="Assignment will be posted"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    HandleAssignAssignment(item._id);
                  }}
                >
                  ASSIGN
                </button>
              ) : (
                <button
                  className="rounded-lg px-4 py-2  text-white bg-[#3470E4] whitespace-nowrap transition-all duration-200 hover:tracking-[1.25px] hover:bg-blue-800"
                  onClick={onView}
                >
                  VIEW SUBMISSIONS
                </button>
              )} */}

            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                item.assigned ? onView() : HandleAssignAssignment(item._id);
              }}
              className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium tracking-wide text-white transition-all hover:bg-blue-700 hover:tracking-wider"
            >
              {item.assigned ? "VIEW SUBMISSIONS" : "ASSIGN"}
            </button>
          </div>
        </div>

        <div className="mt-4 flex items-center gap-2 text-sm text-gray-600">
          <CiUser size={16} />
          <span>{item.instructorName}</span>
        </div>

        <div className="mt-4">
          {item.all ? (
            <span className="inline-flex items-center gap-1 rounded-full bg-pink-100 px-3 py-1 text-xs font-medium text-pink-700">
              All Batches
              <IoIosCheckmarkCircleOutline className="w-5 h-5 font-extrabold" />
            </span>
          ) : (
            <div className="flex flex-wrap gap-2">
              {item.batch.map((batch) => (
                <span
                  key={batch}
                  className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-600"
                >
                  {batch}
                </span>
              ))}
            </div>
          )}
        </div>
        <div className="mt-4">
          <button
            onClick={() => setShowDueDates(!showDueDates)}
            className="inline-flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-gray-900"
          >
            Due Dates
            {showDueDates ? (
              <FaChevronUp className="mt-1" />
            ) : (
              <FaChevronDown className="mt-1" />
            )}
          </button>
          {showDueDates && (
            <div className="animate-show  flex flex-wrap gap-2 mt-2">
              {Object.entries(item.dueDates).map(([batch, date]) => (
                <div
                  key={batch}
                  className="card w-60 bg-white shadow-md border border-gray-200 rounded-lg hover:shadow-lg transition-shadow"
                >
                  <button className="inline-flex items-center gap-2 rounded-lg bg-red-50 px-3 py-1.5 text-sm font-medium">
                    <span className="text-red-600">{batch}</span>
                    <span className="text-gray-600">
                      {Utils.formatDateTime(date)}
                    </span>
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="mt-4">
          <div className="flex justify-between">
            <button
              onClick={() => setShowQuestions(!showQuestions)}
              className="inline-flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-gray-900"
            >
              Questions
              {showQuestions ? (
                <FaChevronUp className="mt-1" />
              ) : (
                <FaChevronDown className="mt-1" />
              )}
            </button>
            <button
              disabled
              className="inline-flex  items-center gap-2 text-sm font-medium text-gray-700 hover:text-gray-900"
            >
              Max Marks :{" "}
              <span> {item.maxMarks >= 0 ? item.maxMarks : "N/A"} </span>
            </button>
          </div>
          {showQuestions && (
            <div className="mt-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
              <QuestionList
                props={{
                  assignmentId: item._id,
                  ques: item.questions,
                  assignment: item,
                  setAssignments,
                }}
              />
            </div>
          )}
        </div>
      </div>
      <span className="text-xs text-gray-600 mt-1 -mb-3  italic flex">
        {Utils.formatDateTime(item.createdAt)}
      </span>
    </div>
  );
};

export default AdminAssignmentCard;
